<template>
    <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition"
            v-model="value"
    >
        <v-card v-if="card.api.getLoaded">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ $t('title.editCard') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save()">
                        <v-icon left>save</v-icon>
                        {{ $t('nav.save') }}
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container>
                <v-row>
                    <v-col cols="12" md="6">
                        <language-input v-model="card.lang"></language-input>
                    </v-col>
                    <v-col cols="12" md="6">
                        <language-input v-model="card.backLang"></language-input>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-textarea
                                :class="frontCss"
                                name="front"
                                :label="$t('field.front')"
                                v-model="card.front"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-textarea
                                :class="backCss"
                                name="back"
                                :label="$t('field.back')"
                                v-model="card.back"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <div>
                    {{ message }}
                </div>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    // import DetailBase from "../bases/DetailBase";
    import LanguageInput from "../widgets/LanguageInput";
    import {Card} from "@/models/Card";

    export default {
        name: "CardEdit",
        components: {LanguageInput},
        // extends: DetailBase,
        data: function () {
            return {
                detailUrl: '/card/',
                message: '',
                submitted: null,
                card: new Card(),
            }
        },
        props: {
            pk: {
                required: true,
                type: Number,
            },
            value: {
                required: true,
                type: Boolean,
            }
        },
        watch: {
            pk: function () {
                // this.getDetail();
            },
            value: function() {
                this.stateChange();
            }
        },
        methods: {
            stateChange () {
                if (this.value) {
                    this.fetch();
                }
            },
            fetch () {
                this.card.api.fetch(this.pk);
            },
            save () {
                let that = this;
                this.card.api.save().then(function () {
                    // eslint-disable-next-line no-console
                    console.log('saved successfully');
                    that.$emit('saved', that.card);
                    that.close();
                }).catch(function (error) {
                    this.message = error;
                });
            },
            cancel () {
                this.message = 'Cancel clicked.';
            },
            close () {
              // this.value = false;
              this.$emit('closed')
            },
        },
        computed: {
            frontCss () {
                return 'lang-' + this.card.lang + ' front-' + this.card.lang + ' front';
            },
            backCss () {
                return 'lang-' + this.card.backLang + ' back-' + this.card.backLang + ' back';
            },
        },
        created () {
        }
    }
</script>

<style scoped>
    .front {
        font-size: 200%;
    }
    .front-HE, .front-AR, .back-HE, .back-AR {
        direction: rtl;
    }
    .back {
        font-size: 150%
    }
</style>
